const VIDEO_SRC =
  'https://storage.readdy-site.link/project_files/d45d6433-09d1-4f4c-94b0-3f34b93f0615/7c3a579c-ccd7-4269-870d-5ae1112a8c68_car.mp4?v=f14617ee2f19ce9472ad98e8ae542320';

const POSTER_SRC =
  'https://public.readdy.ai/ai/img_res/0b0a6284f28b76daaef0266ada3a448a.jpg+sleek+futuristic+electric+wheelchair+with+matte+black+carbon+fiber+frame+moving+through+a+dramatic+dark+urban+environment+at+night%2C+cinematic+wide+shot+with+deep+contrast+shadows%2C+subtle+teal+accent+rim+lighting+on+the+frame%2C+wet+reflective+dark+concrete+ground%2C+blurred+bokeh+city+lights+in+background%2C+ultra+dramatic+moody+atmosphere%2C+high+contrast+professional+product+photography%2C+dark+powerful+composition+emphasizing+freedom+and+independence%2C+minimal+dark+background&width=800&height=1400&seq=ind-hero-poster-v1&orientation=portrait';

export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <video
          src={VIDEO_SRC}
          poster={POSTER_SRC}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>
      </div>

      <div className="relative h-full flex flex-col items-center justify-center text-center px-6 w-full">
        <div className="max-w-4xl w-full">
          <h1 className="text-4xl sm:text-5xl md:text-8xl font-black mb-4 md:mb-6 tracking-tight leading-none">
            POWERING YOUR INDEPENDENCE
          </h1>
          <p className="text-base sm:text-lg md:text-2xl mb-6 md:mb-8 text-gray-300 font-light">
            E-CHAIRS BUILT FOR THE REAL WORLD
          </p>
        </div>
      </div>
    </section>
  );
}
